<script>
import PickupInfoDialog from "@/views/trips/view/dialogs/PickupInfoDialog.vue";
import { mapActions } from "pinia";
import { useSnackbarStore } from "@/store/snackbar.store";

export default {
  name: "LoadVerificationAction",
  components: {
    PickupInfoDialog,
  },
  inheritAttrs: false,
  props: {
    trip: Object,
    route: Object,
    stop: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["verify"],
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    ...mapActions(useSnackbarStore, ["showSnackbarError"]),
    showLoadVerification() {
      this.showDialog = true;
    },
    save() {
      this.$emit("verify");
    },
  },
};
</script>

<template>
  <v-btn
    :disabled="disabled"
    block
    class="text-uppercase font-weight-600"
    color="primary"
    v-bind="$attrs"
    variant="flat"
    @click="showLoadVerification"
  >
    Verify
  </v-btn>
  <pickup-info-dialog
    v-model="showDialog"
    :route="route"
    :stop="stop"
    :trip-id="trip.id"
    preload
    title="Verify information"
    @save="save"
  ></pickup-info-dialog>
</template>

<style lang="scss" scoped></style>
